import React, { PureComponent } from 'react'
import { View, TouchableOpacity } from 'react-native'

export default class Touchable extends PureComponent {
  render () {
    const { onPress, children, touchableStyle = {}, ...props } = this.props
    const disabled = props.disabled || false
    return (
      <TouchableOpacity onPress={onPress} disabled={disabled} style={touchableStyle}>
        <View {...props}>
          {children}
        </View>
      </TouchableOpacity>
    )
  }
}
